import { createContext } from "react";

import { DomainNames, NotificationMessage } from "services/app/types";
import { User } from "services/users/types";

export type ScreenType = "mobile" | "tablet" | "desktop";
export interface AppContextProps {
  user: User | null | undefined;
  setUser: (user: User | null | undefined) => void;
  navHeight: number;
  setNavHeight: (navHeight: number) => void;
  screenType: ScreenType;
  domainNames: DomainNames;
  notificationMessages?: NotificationMessage[];
  setNotificationMessages?: (
    notificationMessages: NotificationMessage[],
  ) => void;
}

export const defaultAppContext: AppContextProps = {
  user: null,
  setUser: () => undefined,
  navHeight: 0,
  setNavHeight: () => undefined,
  screenType: null,
  domainNames: null,
  notificationMessages: [],
  setNotificationMessages: () => undefined,
};

export const AppContext = createContext<AppContextProps>(defaultAppContext);
